import React from "react";

import type { FilterType, CalendarView } from "@/types/calendar";

interface CalendarControlsProps {
  currentView: CalendarView;
  onViewChange: (view: CalendarView) => void;
  activeFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}

export const CalendarControls: React.FC<CalendarControlsProps> = ({
  currentView,
  onViewChange,
  activeFilter,
  onFilterChange,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-2 md:p-4 mb-2 md:mb-4">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 md:gap-4">
        {/* View Controls */}
        <div
          className="flex gap-1 md:gap-2 overflow-x-auto md:overflow-visible md:flex-wrap"
          style={{ scrollbarWidth: "none" }}
        >
          {(["month", "week", "day", "agenda", "map"] as CalendarView[]).map(
            (view) => (
              <button
                key={view}
                onClick={() => onViewChange(view)}
                className={`
                px-3 py-1.5 text-sm md:px-4 md:py-2 md:text-base rounded-lg font-medium transition-colors whitespace-nowrap
                ${
                  currentView === view
                    ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-sm"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }
              `}
              >
                {view === "agenda"
                  ? "List"
                  : view === "map"
                    ? "Map"
                    : view.charAt(0).toUpperCase() + view.slice(1)}
              </button>
            ),
          )}
        </div>

        {/* Filter Tabs */}
        <div className="flex gap-1 md:gap-2">
          {(["all", "upcoming", "past"] as FilterType[]).map((filter) => (
            <button
              key={filter}
              onClick={() => onFilterChange(filter)}
              className={`
                px-2.5 py-1.5 text-sm md:px-3 md:py-2 rounded-lg font-medium transition-colors whitespace-nowrap
                ${
                  activeFilter === filter
                    ? "bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-sm"
                    : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }
              `}
            >
              {filter.charAt(0).toUpperCase() + filter.slice(1)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
